@if (visible()) {
  @let s = summary()!;
  <section class="summary" aria-label="Resumo cadastral">
    <header class="summary__head">
      <div>
        <h3 class="summary__title">Resumo cadastral · Cognito</h3>
        <p class="summary__subtitle">Consultas cadastrais da empresa, só o que importa para a decisão</p>
      </div>
      <span class="summary__status">{{ s.status }}</span>
    </header>

    <ul class="summary__list">
      @for (check of s.checks; track check.label) {
        <li class="summary__row">
          <span class="summary__label">{{ check.label }}</span>
          <span class="summary__result" [class.summary__result--alert]="check.tone === 'alert'">
            {{ check.result }}
          </span>
          <span
            class="summary__dot"
            [class.summary__dot--ok]="check.tone === 'ok'"
            [class.summary__dot--pending]="check.tone === 'pending'"
            [class.summary__dot--alert]="check.tone === 'alert'"
            aria-hidden="true"></span>
        </li>
      }
    </ul>

    @if (s.engineReading) {
      <p class="summary__reading"><strong>Leitura do motor:</strong> {{ s.engineReading }}</p>
    }
    <p class="summary__foot">Conteúdo interno: nunca é exposto ao parceiro.</p>
  </section>
}
